import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";


export default React.createClass({
  displayName: "zoom-browser-docker-help",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {

    return {
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container zoom_docker">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>FaceTec iOS Integration Guide</h2>
                </div>
                <p>These steps walk you through the initial integration of the FaceTec iOS SDK into your application.</p>
                <hr/>
              </section>

              <section id="FaceTec Device SDK: Features & Options">
                <h3>Getting Started</h3>
                <p>These instructions will get the FaceTec Browser SDK running on your local dev machine.  The steps are the same for remote machines.</p>
                <br/>

                <h3>Prerequisites</h3>
                <p>You will need to download, and install <a href="https://www.docker.com/" target="_blank">Docker</a></p>

                <br/>

                <h3>Check out our ~2 minute video walkthrough:</h3>
                <p className="small">Note: This video also shows steps to run the FaceTec Server SDK (Dockerized).   This is not required for initial testing against the FaceTec Testing API.</p>
                <p></p>
                <div className="embed-responsive embed-responsive-16by9" >
                  <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/BFBH8Obq7Ag" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                <p></p>
                <p></p>

                <br/>
                <h3>UI Customization</h3>
                <p>The best way to get started with UI Customization is to take a look at the Sample App Design Showcase.  Once you toggle through the themes and get a feel for the types of changes you can make, take a look at the Sample App theme code to understand how customizations are changed.  Then, you can check out the <Link to="/ui-customization">UI Customization</Link> guide for references to each UI element and how to change it.</p>

              </section>

              <SDKSidebar menuType="main" title="FaceTec Browser Docker Help"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-ios.jsx